import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Seperator from "../Atoms/Seperator";
import "./navigation.header.css";

const sidebarItems = [
  {
    name: "Agents",
    path: "/agents",
  },
  {
    name: "Solutions",
    path: "/solutions",
  },
];

const NavigationHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [selected, setSelected] = useState("Agents");

  // Update selected state based on current pathname
  useEffect(() => {
    if (location.pathname.startsWith("/agents")) {
      setSelected("Agents");
    } else if (location.pathname.startsWith("/solutions")) {
      setSelected("Solutions");
    } else {
      setSelected("");
    }
  }, [location.pathname]);

  if (
    location.pathname === "/" ||
    location.pathname === "/not-authorize" ||
    location.pathname === "/settings"
  ) {
    return null;
  }

  const handleSelection = (name, path) => {
    setSelected(name);
    navigate(path);
  };

  return (
    <>
      <div className="marketplace-nav-bar dashboard-header-sol">
        <div className="nav-items">
          {sidebarItems.map((item) => (
            <div
              key={item.name}
              className={`nav-item ${
                selected === item.name ? "active" : "inactive"
              }`}
              onClick={() => handleSelection(item.name, item.path)}
            >
              {item.name}
            </div>
          ))}
        </div>
      </div>
      <Seperator
        styles={{
          border: 0,
          borderTop: "1px solid var(--db-secondary-gray-four)",
          strokeWidth: "O.5px",
          margin: "0",
          width: "100%",
        }}
      />
    </>
  );
};

export default NavigationHeader;
